import React, { Component } from "react";

import { ButtonsBar } from "./ButtonsBar";
import { StandardButton } from "./StandardButton";

export interface ITabWorkflowButtonsProps {
    dirty: boolean;
    unsaved?: boolean;
    onSave: () => void;
    onNext?: () => void;
    hidden?: boolean;
    loading: boolean;
    saveCopy?: string;
    children?: React.ReactNode;
}

export class TabWorkflowButtons extends Component<ITabWorkflowButtonsProps> {
    public render() {
        const {
            dirty,
            unsaved,
            onSave,
            onNext,
            hidden,
            children,
            loading,
            saveCopy,
        } = this.props;
        const hasChildren = !!React.Children.count(children);
        const collapsed = hidden || !(unsaved || dirty || hasChildren);
        return (
            <ButtonsBar collapsed={collapsed}>
                {children}
                {unsaved && onNext && (
                    <StandardButton
                        primary={true}
                        large={true}
                        onClicked={onNext}
                        data-testid="next-button"
                    >
                        Next
                    </StandardButton>
                )}
                {(!unsaved || !onNext) && (
                    <StandardButton
                        primary={true}
                        large={true}
                        onClicked={onSave}
                        loading={loading}
                        disabled={!unsaved && !dirty}
                        data-testid="save-button"
                    >
                        {saveCopy || "Save"}
                    </StandardButton>
                )}
            </ButtonsBar>
        );
    }
}
